import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ErrorBoundary from '../ai2/components/Error/ErrorBoundary';

interface Props {
  isAuthenticated: boolean;
  isLoading?: boolean;
  initialise: () => void;
  children: React.ReactNode;
}

function ProtectedRoute({
  isAuthenticated,
  isLoading,
  initialise,
  children,
}: Props) {
  const location = useLocation();

  React.useEffect(() => {
    if (isLoading) {
      initialise();
    }
  }, [isLoading, initialise]);

  if (isLoading) {
    return <></>;
  }

  return isAuthenticated ? (
    <ErrorBoundary key={`${location.pathname}${location.search}`}>
      {children}
    </ErrorBoundary>
  ) : (
    <Navigate to="/login" replace />
  );
}

export default ProtectedRoute;
